// Segmented Control Component
export const SegmentedControl = ({ options, selectedValue, onChange, name }) => {
    return (
        <div
            className="segmented-control-container"
            role="radiogroup"
            aria-label={name || 'Segmented control'}
        >
            {options.map((option) => {
                const isActive = selectedValue === option.value;
                return (
                    <button
                        key={option.value.toString()}
                        type="button"
                        role="radio"
                        aria-checked={isActive}
                        data-label={String(option.label)}
                        className={`segmented-control-button ${isActive ? 'active' : ''}`}
                        onClick={() => onChange(option.value)}
                    >
                        {option.label}
                    </button>
                );
            })}
        </div>
    );
};
